import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-reset-request',
  templateUrl: './reset-request.component.html',
  styleUrls: ['./reset-request.component.scss']
})
export class ResetRequestComponent implements OnInit {

  

  showDetails: boolean = false;
  panelOpenState = false;
  activeTab = 0;
  user_id:any; reject_reason: string="";
  course_id:any;assessment_id:any; request_status:number=1;
  
 showDetailsEvent() { this.showDetails = !this.showDetails;  }
  closeResult = '';type:any='';userLoginData:any=[];courseId:any='';userId:any='';assignDetailResume:any=[];assignDetailResumePro:any=[];
  constructor(private router: Router,private authUser: UsersService,private route: ActivatedRoute,private spinner: NgxSpinnerService,
    private modalService: NgbModal,private contentAuthoringApi: ContentAuthoringService,) { 
    
    //alert("hello1");
  }
  ngOnInit(): void {
    //alert("hello2");
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.userId = queryParams['userId'];
      this.courseId = queryParams['courseId'];
      this.type = queryParams['type'];
    });
    if (this.userId =='' || this.userId == null || this.courseId =='' || this.courseId == null ) {
      this.router.navigateByUrl('/admin-login');
    }
    if((this.userId !='' || this.userId != null) && (this.courseId !='' || this.courseId !=null)){
      this.assignCourseDetail(this.userId);
    }
  }
  open(content: any, data:any) { 
    console.log(data);
    //this.user_id = this.userLoginData.user_id
    this.user_id = this.userId
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.contactAdministrator(this.user_id,this.course_id,this.assessment_id, this.request_status)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  /*******get course detail with progress */
  assignCourseDetail(userId:any){
    this.spinner.show();
    this.contentAuthoringApi.assignCourseDetails(userId,this.courseId).subscribe(
      data=>{
        console.log(data,'assignCourseDetail');
        this.assignDetailResume = data.data;
        this.assignDetailResumePro = data.data.user_course_progress;
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
        //console.log(error);
      }
    )
  }
  /*****second convert into hr min and sec */
  secondsToHms(d:any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return h+ ' hr ' +m+ ' min'; 
}
  /****go read submodule */
  goViewer(modId:any,subModlId:any,courseId:any){
    this.spinner.show();
    this.contentAuthoringApi.subModuleStartView(this.userId,courseId,modId,subModlId).subscribe(
      data=>{
        this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId} });
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  /****go read submodule */
  goViewerPass(modId:any,subModlId:any,courseId:any,view:any){
    this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId,view:view} });
  }
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any){
    this.spinner.show();
    this.contentAuthoringApi.contactAdministrator(user_id,course_id,assessment_id, request_status).subscribe(
      data=>{
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  openAccept(content: any, data:any,user_ID:any) { 
    //console.log(data);
    this.user_id = user_ID
    this.course_id=data.course_id
    // if((data.module_assessment_id !='' || data.module_assessment_id !=null) && data.module_attempt_num != 3 && data.module_is_passed != 1 && data.is_module_assessment==1){
    if((data.module_assessment_id !='' || data.module_assessment_id !=null) && data.module_is_passed != 1 && data.is_module_assessment==1 && (data.assessment_id !='' || data.assessment_id != null) && data.is_assessment !=0 && data.assessment_is_passed ==1 ){
      this.assessment_id= data.module_assessment_id
    }else if((data.module_assessment_id !='' || data.module_assessment_id !=null) && data.module_is_passed != 1 && data.is_module_assessment==1 && (data.assessment_id =='' || data.assessment_id == null) && data.is_assessment == 0  ){
      this.assessment_id= data.module_assessment_id
    }else{
      this.assessment_id= data.assessment_id
    }
    this.request_status=2
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  acceptRejectCourses(user_id:number,course_id:any,assessment_id:any, request_status:any, reject_reason:any){
    this.spinner.show();
    this.contentAuthoringApi.ViewCoursesAcceptReject(user_id,course_id,assessment_id, request_status, reject_reason).subscribe(
      data=>{
       //console.log(data)
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  openReject(content: any, data:any,user_ID:any) { 
    this.user_id = user_ID
    this.course_id=data.course_id
    if((data.module_assessment_id !='' || data.module_assessment_id !=null)  && data.module_is_passed != 1 && data.is_module_assessment==1){
      this.assessment_id= data.module_assessment_id
    }else{
      this.assessment_id= data.assessment_id
    }
    this.request_status=3
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  goToReset(){
    this.router.navigate(['/reset']);
  }


}
